<style>
    .pagination>li>a,
    .pagination>li>span {
        padding: 6px 7.5px;
    }
</style>

<!-- <section class="content-header">
    <h1>
        {{title}}
    </h1>
</section> -->
<section class="content">

    <section>
      
        <div class="row">
           
            <!-- /.box -->
            <div class="box  box-primary">
                <PageHeader class="pageHeaderButtonPosition"
                      [title]="'Contact'"
                      [showAddNew]="blnshowAddNew"
                      [addurl]="AddUrl"
                      #pageheader
                      [(searchText)]="searchText"
                      [isSearchOpen]="ShowSearch"
                      (searchShowChange)="onSearchShowChange($event)"
                      [showMainListing]="false"
                      [showImportContact]="true"
                      [showImportVendor]="true"
                      [showDownloadTemplate]="true"
                      (downloadTemplateClick)="onDownloadTemplate()"
                      (importContactClick)="openImportModal()"
                      (importVendorClick)="openVendorModal()">
                      >
                    </PageHeader>
                
                <div id="divSearch row" *ngIf="ShowSearch">
                    <div class="col-md-12 box ibox box-primary boxSearch">
                        <div class="box-header">
                            <h3 class="box-title">Search Records</h3>
                        </div>
                        <div class="box-body">
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label class="col-sm-6 control-label">First Name:</label>
                                            <div class="col-sm-6">
                                                <input type="text" class="form-control" [(ngModel)]="GivenName">
                                            </div>

                                        </div>
                                        <div class="clearfix"></div>
                                    </div>
                                    <div class="col-sm-6">
                                        <div>
                                            <label class="col-sm-6 control-label">Last name:</label>
                                            <div class="col-sm-6">
                                                <input type="text" class="form-control" [(ngModel)]="FamilyName">

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="box-body">
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="col-sm-6">
                                        <div>
                                            <label class="col-sm-6 control-label">User Name:</label>
                                            <div class="col-sm-6">
                                                <input type="text" class="form-control" [(ngModel)]="UserName">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-6">

                                        <label class="col-sm-6 control-label">Contact Type:</label>
                                        <div class="col-sm-6">
                                            <select class="form-control" [(ngModel)]="ContactType">
                                                <option value="{{item.value}}" *ngFor="let item of ContactTypeList">
                                                    {{item.text}}</option>
                                            </select>

                                        </div>
                                    </div>
                                    <div class="clearfix"></div>
                                </div>
                            </div>
                        </div>
                        <div class="box-body">
                            <div class="row">
                                <div class="col-sm-12">
                                    <!-- <div class="col-sm-6">
                                        <div>
                                            <label class="col-sm-6 control-label">Division:</label>
                                            <div class="col-sm-6">
                                                <select class="form-control" [(ngModel)]="Division">
                                                    <option value="{{item.value}}" *ngFor="let item of DivisionList">
                                                        {{item.text}}</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div> -->
                                    <div class="col-sm-6">

                                        <label class="col-sm-6 control-label">Designation:</label>
                                        <div class="col-sm-6">
                                            <select class="form-control" [(ngModel)]="Designation">
                                                <option value="{{item.value}}" *ngFor="let item of DesignationList">
                                                    {{item.text}}</option>
                                            </select>

                                        </div>

                                    </div>
                                    <div class="col-sm-6">

                                        <label class="col-sm-6 control-label">Status:</label>
                                        <div class="col-sm-6">
                                            <select class="form-control" [(ngModel)]="Status">
                                                <option value="{{item.value}}" *ngFor="let item of StatusList">
                                                    {{item.text}}</option>
                                            </select>


                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <!-- <div class="box-body row">
                            <div class="col-sm-12">
                                <div class="col text-center">
                                    <button class="btn btn-primary" id="btnSearchDetail"
                                        (click)="executeContactSearch()">
                                        <span><i class="fa fa-search"></i></span>
                                        <b>&nbsp;Search</b>
                                    </button>
                                </div>
                            </div>

                        </div> -->
                        <searchbutton (searchClick)="executeContactSearch()" (cancelClick)="hideSearch()"></searchbutton>
                    </div>
                </div>
                <div class="clearfix"></div>
                <div class="box-body" id="dvboxbody">
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="col-sm-7 pull-right zIndex1000">
                                <nav>
                                    <ul class="pagination" *ngIf="prefixAlphabet">
                                        <li>
                                            <a href="javascript:void(0)" (click)="clearAlphabet()">
                                                <i class="fa fa-refresh" aria-hidden="true"></i></a>
                                        </li>
                                    </ul>
                                    <ul class="pagination pull-right">
                                        <!-- <li class="disabled"><a href="#" aria-label="Previous"><span aria-hidden="true">�</span></a></li>  -->
                                        <li [ngClass]="{'active':alphabet==prefixAlphabet}"
                                            *ngFor="let alphabet of alphaBetsList">
                                            <a href="javascript:void(0)"
                                                (click)="alphabetChange(alphabet)">{{alphabet}}</a>
                                        </li>
                                        <!-- <li class="disabled"><a href="#">Y</a></li> -->
                                        <!-- <li><a href="#" aria-label="Next"><span aria-hidden="true">�</span></a></li>  -->
                                    </ul>
                                </nav>
                            </div>
                            <div class="col-sm-2 pull-right noBorderSearchPadding">
                                <!-- <div class="col-sm-12"> -->
                                    <select class="form-control noBorderSearch" [(ngModel)]="Division"
                                        (change)="DialysisUnitDropDownChanged()" style="padding:0px;">
                                        <option value="{{item.value}}" *ngFor="let item of DivisionList">
                                            {{item.text}}
                                        </option>
                                    </select>
                                <!-- </div> -->
                            </div>
                            <div class="col-sm-3">
                                <div class="col text-left noofrecords">
                                    <span><b>  {{page.totalElements}}
                                                {{page.totalElements > 1 ? 'Records' : 'Record'}} Found. </b></span>
                                    <span *ngIf="blnDirtySearch"><a style="cursor:pointer"
                                            (click)="executeContactSearchClear()">
                                            (<span><i class="fa fa-trash-o"></i></span>&nbsp;
                                            <b>Clear Search</b>
                                        </a>)
                                    </span>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="col-sm-12">
                            <div class="col-sm-9 pull-right">
                                <div class="col text-right">
                                    <ngb-pagination pageSize="25" [boundaryLinks]="true"
                                        [collectionSize]="page.totalElements" [(page)]="page.pageNumber"
                                        (pageChange)="setPage()" [maxSize]="10" [directionLinks]="true">
                                    </ngb-pagination>
                                </div>
                            </div>
                            <div class="col-sm-3">
                                <div class="col text-left noofrecords">
                                    <span><b> <i>{{page.totalElements}}
                                                {{page.totalElements > 1 ? 'Records' : 'Record'}} Found.</i></b></span>
                                    <span *ngIf="blnDirtySearch"><a style="cursor:pointer"
                                            (click)="executeContactSearchClear()">
                                            (<span><i class="fa fa-trash-o"></i></span>&nbsp;
                                            <b>Clear Search</b>
                                        </a>)
                                    </span>
                                </div>
                            </div>
                        </div> -->
                    </div>
                    <div class="table-responsive-custom">
                        <table id="OptionList" class="table table-bordered table-striped dataTable no-footer"
                            role="grid" style="
                    overflow-x: auto;
                    white-space: nowrap;">
                            <thead>



                                <tr>
                                    <th *ngFor="let tableHeader of tableHeaders"
                                        [ngClass]="setSortIndicator(tableHeader.Label)"
                                        [style.width.%]="tableHeader.Width" (click)="changeSorting(tableHeader.Label)">
                                        {{tableHeader.Label}}</th>
                                </tr>
                            </thead>
                            <tbody>



                                <tr *ngFor="let ContanctDetail of rows;let index=index;"
                                    (click)="_onRowClick(ContanctDetail.contactid)" class="pointer">

                                    <td>

                                        {{(pageSize*(currentPageNumber-1)) + (index + 1)}}
                                    </td>
                                    <td *ngIf='ContanctDetail.contacttype == "Vendor"'>
                                        {{ContanctDetail.givenname}} <span
                                            *ngIf='ContanctDetail.familyname.trim().length > 0'> -
                                            {{ContanctDetail.familyname}} </span>
                                    </td>
                                    <td *ngIf='ContanctDetail.contacttype != "Vendor"'>
                                        {{ContanctDetail.givenname}} {{ContanctDetail.familyname}}
                                    </td>

                                    <!-- <td >{{ContanctDetail.contactnumber}}</td> -->
                                    <td *ngIf='ContanctDetail.contacttype != "User"'>{{ContanctDetail.emailaddress}}</td>
                                    <td *ngIf='ContanctDetail.contacttype == "User"'>{{ContanctDetail.username}}</td>
                                    <td>{{ContanctDetail.phone}}</td> 
                                    <!-- <td *ngIf="ContanctDetail.phone == '' && ContanctDetail.cellphone != ''">C-{{ContanctDetail.cellphone}}</td>
                                    <td *ngIf="ContanctDetail.cellphone == ''  && ContanctDetail.tollfreefax != ''">T-{{ContanctDetail.tollfreefax}}</td>                                     -->
                                    <!-- <td *ngIf="ContactDetail.cellphone == '' && ContactDetail.tollfreefax != ''">T-{{ContactDetail.tollfreefax}}</td> -->
                                    <td>{{ContanctDetail.contacttype}}</td>
                                    <td>{{ContanctDetail.designation}}</td>

                                    <td>{{ContanctDetail.status}} </td>
                                </tr>
                            </tbody>


                        </table>
                    </div>
                    <!-- <div class="row">
                    <div class="col-lg-12 text-center">
                      <ngb-pagination pageSize="25" [boundaryLinks]="true" [collectionSize]="page.totalElements" [(page)]="page.pageNumber" (pageChange)="setPage()" [maxSize]="10" [directionLinks]="true"></ngb-pagination>
                    </div>
                    </div> -->
                    <div class="row">
                        <!-- <div class="col-sm-12">
                            <div class="col-sm-9 pull-right">
                                <div class="col text-right">
                                    <ngb-pagination pageSize="25" [boundaryLinks]="true"
                                        [collectionSize]="page.totalElements" [(page)]="page.pageNumber"
                                        (pageChange)="setPage()" [maxSize]="10" [directionLinks]="true">
                                    </ngb-pagination>
                                </div>
                            </div>
                            <div class="col-sm-3">
                                <div class="col text-left noofrecords">
                                    <span><b> <i>{{page.totalElements}}
                                                {{page.totalElements > 1 ? 'Records' : 'Record'}} Found.</i></b></span>
                                    <span *ngIf="blnDirtySearch"><a style="cursor:pointer"
                                            (click)="executeContactSearchClear()">
                                            (<span><i class="fa fa-trash-o"></i></span>&nbsp;
                                            <b>Clear Search</b>
                                        </a>)
                                    </span>
                                </div>
                            </div>
                        </div> -->
                        <div class="col-sm-12">
                            <div class="col-sm-3">
                                <div class="col text-left noofrecords">
                                    <span><b>  {{page.totalElements}}
                                                {{page.totalElements > 1 ? 'Records' : 'Record'}} Found. </b></span>
                                    <span *ngIf="blnDirtySearch"><a style="cursor:pointer"
                                            (click)="executeContactSearchClear()">
                                            (<span><i class="fa fa-trash-o"></i></span>&nbsp;
                                            <b>Clear Search</b>
                                        </a>)
                                    </span>
                                </div>
                            </div>
                            <div class="col-sm-7 col-sm-offset-2">
                                <nav>
                                    <ul class="pagination" *ngIf="prefixAlphabet">
                                        <li>
                                            <a href="javascript:void(0)" (click)="clearAlphabet()" title="Reset">
                                                <i class="fa fa-refresh" aria-hidden="true"></i></a>
                                        </li>
                                    </ul>
                                    <ul class="pagination pull-right">
                                        <!-- <li class="disabled"><a href="#" aria-label="Previous"><span aria-hidden="true">�</span></a></li>  -->
                                        <li [ngClass]="{'active':alphabet==prefixAlphabet}"
                                            *ngFor="let alphabet of alphaBetsList">
                                            <a href="javascript:void(0)"
                                                (click)="alphabetChange(alphabet)">{{alphabet}}</a>
                                        </li>
                                        <!-- <li class="disabled"><a href="#">Y</a></li> -->
                                        <!-- <li><a href="#" aria-label="Next"><span aria-hidden="true">�</span></a></li>  -->
                                    </ul>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- Import Excel Modal -->
<div class="ph-modal-backdrop" *ngIf="showImportModal">
  <div class="ph-modal">
    <div class="ph-modal-header">
      <h4 class="m-0">Import Contacts</h4>
      <button type="button" class="close" (click)="closeImportModal()">&times;</button>
    </div>

    <div class="ph-modal-body">
      <p class="mb-2">
        Select an Excel file using the template (First Name, Last Name, Email, Mobile Number).
        <a href="javascript:void(0)" (click)="onDownloadTemplate()">Download Template</a>
      </p>

      <!-- File picker -->
      <input type="file" accept=".xlsx,.xls" (change)="onExcelFileChange($event)" />

      <!-- Validate button -->
      <div class="mt-2">
        
      </div>

      <!-- Results section -->
      <div *ngIf="validationDone" class="mt-3">
        <!-- Invalid email table -->
        <div *ngIf="invalidEmailRows.length">
          <h5 class="text-danger">Invalid Email Rows ({{ invalidEmailRows.length }})</h5>
          <div class="table-responsive">
            <table class="table table-sm table-bordered">
              <thead>
                <tr>
                  <th>Row #</th>
                  <th>Email</th>
                  <th>Errors</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let r of invalidEmailRows">
                  <td>{{ r.rowNumber }}</td>
                  <td>{{ r.email || '(blank)' }}</td>
                  <td>{{ (r.errors || []).join('; ') }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="text-muted mb-2">Fix the above rows in Excel and re-upload.</div>
        </div>

        <!-- Other invalid rows (non-email), if any -->
        <div *ngIf="invalidRows.length && (invalidRows.length !== invalidEmailRows.length)">
          <h5 class="text-danger">Other Invalid Rows ({{ invalidRows.length - invalidEmailRows.length }})</h5>
          <div class="table-responsive">
            <table class="table table-sm table-bordered">
              <thead>
                <tr>
                  <th>Row #</th>
                  <th>Email</th>
                  <th>Errors</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let r of invalidRows">
                  <ng-container *ngIf="!(invalidEmailRows | json).includes((r | json))">
                    <td>{{ r.rowNumber }}</td>
                    <td>{{ r.email || '' }}</td>
                    <td>{{ (r.errors || []).join('; ') }}</td>
                  </ng-container>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- Duplicates -->
        <div *ngIf="duplicateInExcel.length || duplicateInDatabase.length" class="mt-3">
            <div class="text-red mb-2" *ngIf="validationDone && validRows.length == 0">Fix the above rows in Excel and re-upload.</div>
          <h5 class="text-warning">Duplicates Found</h5>

          <div *ngIf="duplicateInExcel.length" class="mb-2">
            <strong>In Excel ({{ duplicateInExcel.length }}):</strong>
            <ul class="mb-0">
              <li *ngFor="let r of duplicateInExcel">Row {{ r.rowNumber }} — {{ r.email }}</li>
            </ul>
          </div>

          <div *ngIf="duplicateInDatabase.length">
            <strong>Already in Database ({{ duplicateInDatabase.length }}):</strong>
            <ul class="mb-0">
              <li *ngFor="let r of duplicateInDatabase">{{ r.email }}</li>
            </ul>
          </div>
          
          <small class="text-muted d-block mt-1" *ngIf="validRows.length > 0">You can still import unique rows only.</small>
        </div>

        <!-- Summary -->
        <div class="mt-3">
          <span class="badge bg-success">Valid: {{ validRows.length }}</span>
          <span class="badge bg-danger ms-2">Invalid: {{ invalidRows.length }}</span>
          <span class="badge bg-warning ms-2">Dup(Excel): {{ duplicateInExcel.length }}</span>
          <span class="badge bg-warning ms-2">Dup(DB): {{ duplicateInDatabase.length }}</span>
        </div>
      </div>
    </div>

    <div class="ph-modal-footer">
        <!-- <button class="btn btn-primary" *ngIf="!validationDone || validRows.length == 0" [disabled]="!selectedExcelFile || isValidating" (click)="validateExcelInModal()">
          <span *ngIf="!isValidating">Verify Contact(s)</span>
          <span *ngIf="isValidating">Verifying...</span>
        </button> -->
        <button class="btn btn-primary"
              *ngIf="validationDone && validRows.length > 0 && invalidRows.length == 0"
              [disabled]="isCommitting"
              (click)="confirmImportExcel()">
        <span *ngIf="!isCommitting && (duplicateInDatabase.length > 0 || duplicateInExcel.length > 0)">Import (Unique Only)</span>
        <span *ngIf="!isCommitting && (duplicateInDatabase.length == 0 && duplicateInExcel.length == 0)">Import</span>
        <span *ngIf="isCommitting">Importing...</span>
      </button>
      <!-- <button class="btn btn-secondary" (click)="closeImportModal()">Close</button> -->
      
    </div>
  </div>
</div>

<div class="ph-modal-backdrop" *ngIf="showImportVendor">
  <div class="ph-modal">
    <div class="ph-modal-header">
      <h4 class="m-0">Import Vendors</h4>
      <button type="button" class="close" (click)="closeVendorModal()">&times;</button>
    </div>

    <div class="ph-modal-body">
      <p class="mb-2">
        Select an Excel file using the template (Vendor Name, Mailing Country, Province, Mailing City, Mailing Address, Zip Code, Work Phone, Cell Phone, Fax).
        <a href="javascript:void(0)" (click)="onVendorDownloadTemplate()">Download Template</a>
      </p>

      <!-- File picker -->
      <input type="file" accept=".xlsx,.xls" (change)="onVendorFileChange($event)" />

      <!-- Validate button -->
      <div class="mt-2">
        
      </div>

      <!-- Results section -->
      <div *ngIf="validationDone" class="mt-3">
        <!-- Invalid email table -->
        <div *ngIf="invalidEmailRows.length">
          <h5 class="text-danger">Invalid Email Rows ({{ invalidEmailRows.length }})</h5>
          <div class="table-responsive">
            <table class="table table-sm table-bordered">
              <thead>
                <tr>
                  <th>Row #</th>
                  <th>Email</th>
                  <th>Errors</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let r of invalidEmailRows">
                  <td>{{ r.rowNumber }}</td>
                  <td>{{ r.email || '(blank)' }}</td>
                  <td>{{ (r.errors || []).join('; ') }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="text-muted mb-2">Fix the above rows in Excel and re-upload.</div>
        </div>

        <!-- Other invalid rows (non-email), if any -->
        <div *ngIf="invalidRows.length && (invalidRows.length !== invalidEmailRows.length)">
          <h5 class="text-danger">Other Invalid Rows ({{ invalidRows.length - invalidEmailRows.length }})</h5>
          <div class="table-responsive">
            <table class="table table-sm table-bordered">
              <thead>
                <tr>
                  <th>Row #</th>
                  <th>Email</th>
                  <th>Errors</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let r of invalidRows">
                  <ng-container *ngIf="!(invalidEmailRows | json).includes((r | json))">
                    <td>{{ r.rowNumber }}</td>
                    <td>{{ r.email || '' }}</td>
                    <td>{{ (r.errors || []).join('; ') }}</td>
                  </ng-container>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- Duplicates -->
        <div *ngIf="duplicateInExcel.length || duplicateInDatabase.length" class="mt-3">
            <div class="text-red mb-2" *ngIf="validationDone && validRows.length == 0">Fix the above rows in Excel and re-upload.</div>
          <h5 class="text-warning">Duplicates Found</h5>

          <div *ngIf="duplicateInExcel.length" class="mb-2">
            <strong>In Excel ({{ duplicateInExcel.length }}):</strong>
            <ul class="mb-0">
              <li *ngFor="let r of duplicateInExcel">Row {{ r.rowNumber }} — {{ r.email }}</li>
            </ul>
          </div>

          <div *ngIf="duplicateInDatabase.length">
            <strong>Already in Database ({{ duplicateInDatabase.length }}):</strong>
            <ul class="mb-0">
              <li *ngFor="let r of duplicateInDatabase">{{ r.email }}</li>
            </ul>
          </div>
          
          <small class="text-muted d-block mt-1" *ngIf="validRows.length > 0">You can still import unique rows only.</small>
        </div>

        <div class="mt-3">
          <span class="badge bg-success">Valid: {{ validRows.length }}</span>
          <span class="badge bg-danger ms-2">Invalid: {{ invalidRows.length }}</span>
          <span class="badge bg-warning ms-2">Dup(Excel): {{ duplicateInExcel.length }}</span>
          <span class="badge bg-warning ms-2">Dup(DB): {{ duplicateInDatabase.length }}</span>
        </div>
      </div>
    </div>

    <div class="ph-modal-footer">
        <button class="btn btn-primary"
              *ngIf="validationDone && validRows.length > 0 && invalidRows.length == 0"
              [disabled]="isCommitting"
              (click)="confirmImportVendorExcel()">
        <span *ngIf="!isCommitting && (duplicateInDatabase.length > 0 || duplicateInExcel.length > 0)">Import (Unique Only)</span>
        <span *ngIf="!isCommitting && (duplicateInDatabase.length == 0 && duplicateInExcel.length == 0)">Import</span>
        <span *ngIf="isCommitting">Importing...</span>
      </button>
    </div>
  </div>
</div>
</section>
